import { DSR_API_METHOD_TYPES } from '@lib/sdk/api/modules/dsr/types.dsr'
import { usePostRobot } from '@lib/sdk/utils/postrobot'
import type { File } from '@openapi'
/**
 * Closes the already open file that was opened via api or by the user.
 *
 * @example
 * dsrApi.close()
 */
export async function close(): Promise<void> {
  const pr = await usePostRobot()
  await pr.send(window.parent, DSR_API_METHOD_TYPES.CLOSE)
}

/**
 * Fetches a file by ID.
 *
 * @example
 * dsrApi.getFile({ id: 'my-file-id' })
 */
export async function getFile(payload: { id: File['id'] }): Promise<File> {
  const pr = await usePostRobot()
  const response = await pr.send(window.parent, DSR_API_METHOD_TYPES.GET_FILE, payload)
  return response.data as File
}

/**
 * Retrieves the configuration for the calling app.
 * App name can be optionally provided, otherwise it will be derived from the caller's URL.
 *
 * @example
 * dsrApi.getAppConfig() // for self config
 * // or with explicit app name
 * dsrApi.getAppConfig({ app_name: 'my-app' })
 */
export async function getAppConfig(payload?: { app_name?: string }): Promise<Record<string, any>> {
  const pr = await usePostRobot()
  const response = await pr.send(window.parent, DSR_API_METHOD_TYPES.GET_APP_CONFIG, payload ?? {})
  return response.data as Record<string, any>
}
